import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appSelectOnFocus]',
  standalone: true,
})
export class SelectOnFocusDirective {

  private justFocused = false;

  @HostListener('focusin', ['$event'])
  onFocusIn(event: FocusEvent) {
    if (!(event.target instanceof HTMLInputElement)) { return; }

    event.target.select();
    this.justFocused = true;
  }

  @HostListener('mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    if (!this.justFocused) { return; }

    this.justFocused = false;
    event.preventDefault();
  }

  @HostListener('focusout')
  onFocusOut() {
    this.justFocused = false;
  }
}
